// extracted by mini-css-extract-plugin
export var wordContainer = "_lx-0";